export const projects = [
  {
    title: "Natours",
    subtitle: "MERN Stack",
    description:
      "A Tour Booking Website",
    image: "./Natours.gif",
    link: "https://salty-lake-82539-65ae1cd06c80.herokuapp.com/",
  },
  {
    title: "Fracture Surface Classifier",
    subtitle: "Computer Vision, Research Paper, Heat Map",
    description:
      "Research Project to find the best architecture to classify microscopic images.",
    image: "./fractureClassifier.gif",
    link: "https://github.com/yashk1900/MetalClassification",
  },
  {
    title: "Limited Image Classifier",
    subtitle: "Image Classifiction,Flask, CNN,  Tensorflow",
    description:
      "A web app to classify images uploaded from users.",
    image: "./imgclass.gif",
    link: "https://imgclassifier-d3541d1e2630.herokuapp.com/",
  },
  // {
  //   title: "React Tracks",
  //   subtitle: "React and Python",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-2.gif",
  //   link: "https://reactbootcamp.com",
  // },
];

export const experiences = [
  {
    title: "Lacework",
    subtitle: "Software Engineer Intern",
    description:
      "Developed an alert investigator using Snowflake, SQL, and Python, automating alert analysis and improving developer productivity by 25%. \n Optimized caching, SQL joins, and Snowflake operations to reduce analysis time by 10X.",
    image: "lacework_logo.jpeg",
  },
  {
    title: "Amazon",
    subtitle: "Software Engineer",
    description:
      "Built backend accounting architecture with Java and Ion, doubling order processing capacity.\n Accelerated a major bank discounts project by 4 weeks through improved sprint planning and team coordination.",
    image: "amazon_logo.jpg",
  }
]


export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "C++", "Java", "JavaScript" , "TypeScript" , "Python", "Objectiv-C" , "SQL",
  "Node.js" , "React.js" , "MongoDB" , "MySQL" , "Qt" , "AWS", "Docker" , "Heroku" 
];



// WEBPACK FOOTER //
// ./src/data.js